// extracted by css-extract-rspack-plugin
export default {"content":"lgSNN","category":"sj02q","qrCode":"HYr6O","title":"t1oRA","description":"vLDNA"};